// extracted by css-extract-rspack-plugin
export default {"noBreadcrumbs":"GlobalNavBar-module__noBreadcrumbs__MlKiX"};